import { render } from "./signin-2.vue?vue&type=template&id=384a55eb"
import script from "./signin-2.vue?vue&type=script&lang=js"
export * from "./signin-2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__